import genericApi from './genericApi';

import ApiResponse from '../models/ApiResponse';
import OrderDashboard from '../models/OrderDashboard';
import TapaModel from '../models/TapaForm';

const tapaReqHandler = {
  addUpdateTapa: (tapa: any, id?: number, checks?: string): Promise<ApiResponse<TapaModel>> => {
    const payload = id ? { tapa: tapa, id: id } : { tapa };
    let url = 'tapa';
    if (checks) {
      url = `tapa?checkType=${checks}`;
    }
    return genericApi.put(url, payload);
  },

  deleteTapa: (id: number, orderNumber?: string): Promise<ApiResponse<number>> => {
    let url = `tapa/${id}`;
    if (orderNumber) {
      url = `tapa/${id}?order_number=${orderNumber}`;
    }
    return genericApi.delete(url);
  },

  getSingleFormDetails: (id: number): Promise<ApiResponse<TapaModel>> => {
    return genericApi.get(`tapa/${id}`);
  },

  getTapaForms: (date: string): Promise<ApiResponse<Array<TapaModel>>> => {
    return genericApi.get(`tapa_forms?date=${date}`);
  },

  linkUnlinkTapa: (type: string, orderNumber: string, tapaId?: number): Promise<ApiResponse<boolean>> => {

    let url: string = tapaId ? `link_tapa/${orderNumber}/${tapaId}?type=${type}` : `link_tapa/${orderNumber}?type=${type}`;
    return genericApi.put(url);
  },

  getUnlinkedPickupOrders: (type: string, startDate: string): Promise<ApiResponse<Array<OrderDashboard>>> => {

    let url: string = `pickup_orders?usedFor=${type}&`;
    if (startDate) {
      url = `${url}start_date=${startDate}`;
    };

    return genericApi.get(url);
  }
}

export default tapaReqHandler;